// lib/list/listOutputArchetypes.ts
import { z } from 'zod';
import type { ListOutputArchetypeAssociation } from '#types/types';

const associations = z.array(z.object({
  id: z.string().min(1).max(160), revision: z.number().int().positive().safe(),
  handle: z.string().regex(/^[a-z0-9-]{1,48}$/).optional(), enabled: z.boolean().optional(),
}));

export function readListOutputArchetypes(params: unknown): ListOutputArchetypeAssociation[] | null {
  const record = params && typeof params === 'object' && !Array.isArray(params) ? params as Record<string, unknown> : {};
  const parsed = associations.safeParse(record.listArchetypeContext ?? record.listArchetypes ?? []);
  if (!parsed.success) return null;
  const disabled = record.listArchetypeDisabled && typeof record.listArchetypeDisabled === 'object' && !Array.isArray(record.listArchetypeDisabled) ? record.listArchetypeDisabled as Record<string, unknown> : {};
  return parsed.data.map(archetype => ({ ...archetype, enabled: typeof disabled[archetype.id] === 'boolean' ? !disabled[archetype.id] : archetype.enabled !== false }));
}
